<template>
  <div class="meaning-con">
    <img
      :src="currentItem?.illustration_url"
      alt=""
      class="meaning-img"
      v-if="currentItem?.illustration_url"
      :id="currentItem.id"
    />
    <p class="meaning-text">{{ currentItem?.translation }}</p>
  </div>
</template>
<script>
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
<style lang="scss" scoped>
.meaning-con {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.meaning-img {
  max-width: 126px;
  max-height: 126px;
  object-fit: cover;
}
.meaning-text {
  max-width: 90%;
  padding: 0 10px;
  font-size: 22px;
  font-weight: 700;
  // white-space: nowrap;
  // text-overflow: ellipsis;
  // overflow: hidden;
  word-break: break-word;
  margin-top: 20px;
  color: #2c2f46;
  text-align: center;
  line-height: 33px;
}
</style>
